















































































































































































































































import { signup, User } from "@/services";
import { findUser, updateUser, userDeposit, getUser, findUserCards, findCardTypes, findCoupons, updateCard, Card, CardStatus, CardType, Coupon } from "../../services/user";
import { Sync } from "vuex-pathify";
import { findBookings, createBooking, updateBooking, getBookingPrice, getBooking } from "@/services/booking";
import { moment } from "@/utils/moment";
import { config } from "@/../config";
import { sendPaymentToSunmi, updatePayment, openDrawer, bookingPrint } from "@/services/payment";
import { _ } from "@/utils/lodash";
import { helpers } from "@/utils/helper";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";

// const { $App } = window;

@Component
export default class Create extends Vue {
  @Sync("auth/user") user;
  @Sync("configs") configs;
  @Sync("store/currentStore") currentStore;
  today = moment().format("YYYY-MM-DD");
  step = "searchUser";
  coupons: Coupon[] = [];
  cardTypes: CardType[] = [];
  cardSellForm = {
    confirm: false,
    scanPayCode: false,
    loading_confirm: false,
    card: null,
    coupon: null,
    paymentGateway: "scan",
    payCode: "",
    loading: false,
    payment: { id: "" },
    intervalQueryCardStatus: null
  };
  searchUserForm = {
    user: {
      id: "",
      mobile: "",
      credit: 0,
      cardNo: 0
    },
    card: null,
    bookings: [],
    cards: [],
    bookings_loading: false,
    bindCard_loading: false,
    cardNo: null,
    searchText: "",
    loading: false,
    items: []
  };
  createUserForm = {
    valid: false,
    mobile: "",
    username: "",
    gender: 0,
    loading: false,
    idCardNo: "",
    isForeigner: false,
    country: ""
  };
  createBookingForm = {
    form: {
      type: "play",
      date: moment().format("YYYY-MM-DD"),
      hours: 0,
      adultsCount: 1,
      kidsCount: 0,
      socksCount: 0,
      paymentGateway: "scan",
      checkInAt: "",
      payCode: ""
    },
    user: {
      id: "",
      mobile: "",
      credit: 0
    },
    coupon: { id: "" },
    card: { id: "" },
    useCard: false,
    fixedHours: false,
    price: NaN,
    cardTimes: NaN,
    confirm: false,
    scanPayCode: false,
    loading_price: false,
    loading_confirm: false,
    loading_createBooking: false,
    newBooking: {
      id: "",
      status: "",
      payments: []
    }
  };
  statusName = {
    pending: "待支付",
    valid: "待激活",
    activated: "已激活",
    expired: "已失效",
    canceled: "已取消"
  };
  countries = ["日本", "韩国", "澳大利亚", "美国", "加拿大", "新加坡", "泰国", "马来西亚", "印度", "英国", "德国", "法国", "意大利"];
  watchNewBookingPayStatusInterval = null;
  get paymentGateways() {
    return [
      { label: "扫码", value: "scan", icon: "mdi-qrcode" },
      { label: "验券", value: "coupon", icon: "mdi-ticket" },
      {
        label: "现金",
        value: "cash",
        icon: "mdi-wallet",
        disabled: !this.user.store
      },
      { label: "客扫", value: "customerscan", icon: "mdi-credit-card" }
    ];
  }
  get paymentGateway() {
    if (this.createBookingForm.user.credit > this.createBookingForm.price) {
      return "credit";
    }
    return this.createBookingForm.form.paymentGateway;
  }
  get userValid() {
    if (!this.searchUserForm.user) return false;
    return this.searchUserForm.user.mobile;
  }
  get creditPrice() {
    const price = _.get(this, "createBookingForm.price", 0);
    const credit = _.get(this, "createBookingForm.user.balance", 0);
    return Math.min(price, credit);
  }
  get validCoupons() {
    return this.coupons.filter((i) => {
      if (i.scene !== "play") return false;
      const { start, end } = i;
      if ((start && moment(start).startOf("day").diff() > 0) || (end && moment(end).endOf("day").diff() < 0)) return false;
      return true;
    });
  }
  get validCardCoupons() {
    return this.coupons.filter((i) => {
      if (i.scene !== "card") return false;
      const { start, end } = i;
      if ((start && moment(start).startOf("day").diff() > 0) || (end && moment(end).endOf("day").diff() < 0)) return false;
      if (!i.productNos?.includes(this.cardSellForm.card?.slug)) return false;
      return true;
    });
  }
  @Watch("createUserForm.idCardNo") onCreateUserFormIdCardNoUpdate(val) {
    if (val && val.length === 18) {
      this.createUserForm.gender = val.substr(16, 1) % 2 === 1 ? 1 : 2;
    }
  }
  @Watch("createBookingForm.form", { immediate: true, deep: true }) async onCreateBookingFormFormUpdate(newVal, oldVal) {
    if (!oldVal) return;
    // @ts-ignore
    clearTimeout(this.getPriceTimeout);
    // @ts-ignore
    this.getPriceTimeout = this.updatePrice();
  }
  @Watch("createBookingForm.card") onCreateBookingFormCardUpdate(val) {
    if (!val) {
      this.createBookingForm.card = val = { id: "" };
    }
    const { hours, id, adultsCount, kidsCount } = val || {};
    if (val.id) {
      this.createBookingForm.form.hours = hours || 0;
      this.createBookingForm.form.adultsCount = adultsCount || 0;
      this.createBookingForm.form.kidsCount = kidsCount || 0;
    }
    this.createBookingForm.fixedHours = !!id;
    this.updatePrice();
  }
  @Watch("createBookingForm.coupon") onCreateBookingFormCouponUpdate(val) {
    if (!val) {
      this.createBookingForm.coupon = val = { id: "" };
    }
    const { hours, adultsCount = 1, kidsCount = 0, slug } = val || {};
    if (val.id) {
      this.createBookingForm.form.hours = hours || 0;
      this.createBookingForm.form.adultsCount = adultsCount;
      this.createBookingForm.form.kidsCount = kidsCount;
    }
    this.createBookingForm.fixedHours = hours !== undefined;
    this.updatePrice();
  }
  @Watch("createBookingForm.useCard") onUseCardUpdate() {
    this.createBookingForm.coupon = { id: "" };
    this.createBookingForm.card = { id: "" };
  }
  @Watch("searchUserForm.searchText") async onSearchUserFormSearchTextUpdate(val) {
    const { searchText, loading } = this.searchUserForm;
    if (loading || !searchText || searchText.length < 4) return;
    if (![5, 11, 24].includes(searchText.length)) return;
    this.searchUserForm.loading = true;
    const [err, res] = await helpers.runAsync(findUser({ keyword: searchText }));
    this.searchUserForm.loading = false;

    if (err) {
      return (this.searchUserForm.loading = false);
    }
    // console.log(res.data);
    this.searchUserForm.items = res.data;
  }
  @Watch("searchUserForm.user") async onSearchUserFormUserUpdate(val) {
    const { bookings_loading } = this.searchUserForm;
    if (bookings_loading || !val) return;
    this.searchUserForm.bookings_loading = true;

    this.searchUserForm.bookings = (
      await findBookings({
        customer: val.id,
        date: this.today,
        store: this.currentStore.id,
        status: "booked"
      })
    ).data;

    await this.getUserCards({ scene: "play" });

    if (this.searchUserForm.cards.length) {
      this.createBookingForm.useCard = true;
    }

    this.cardTypes = (await findCardTypes()).data;
    this.coupons = (await findCoupons({ scene: "play,card", limit: false })).data;
    this.searchUserForm.bookings_loading = false;
  }
  @Watch("createUserForm.isForeigner") onCreateUserFormIsForeignerUpdate(val) {
    this.createUserForm.idCardNo = undefined;
  }
  async parseQuery() {
    const { userId } = this.$route.query;
    if (userId) {
      const { data: user } = await getUser({ id: userId });
      this.searchUserForm.user = user;
    }
  }
  async updatePrice() {
    if (this.createBookingForm.loading_price) return;
    this.createBookingForm.loading_price = true;
    this.createBookingForm.price = NaN;
    let { type, date, checkInAt, adultsCount, kidsCount, socksCount, hours } = this.createBookingForm.form;
    const { id: customerId } = this.createBookingForm.user;
    const { id: couponId } = this.createBookingForm.coupon || {};
    const { id: cardId } = this.createBookingForm.card || {};

    const { paymentGateway } = this;

    const [err, res] = await helpers.runAsync(
      getBookingPrice({
        store: this.currentStore.id,
        type,
        date,
        hours,
        card: cardId,
        coupon: couponId,
        customer: customerId,
        checkInAt: moment().format("HH:mm"),
        adultsCount,
        kidsCount,
        socksCount,
        useBalance: true,
        paymentGateway
      })
    );
    this.createBookingForm.loading_price = false;
    if (err) {
      return (this.createBookingForm.loading_price = false);
    }
    this.createBookingForm.price = res.data.price;
    this.createBookingForm.cardTimes = res.data.cardTimes;
  }
  async refreshSearchUser() {
    this.step = "searchUser";
    const { id } = this.searchUserForm.user;
    if (!id) return;
    const res = await getUser({ id });
    this.searchUserForm.user = res.data;
    this.searchUserForm.searchText = res.data.mobile;
  }
  async getUserCards(params: Record<string, any> = {}) {
    const userId = this.searchUserForm.user.id;
    if (!userId) return;
    this.searchUserForm.cards = (await findUserCards({ customer: userId, ...params })).data;
    if (this.searchUserForm.cards.some((c) => c.status === CardStatus.PENDING)) {
      if (!this.cardSellForm.intervalQueryCardStatus) {
        this.watchPendingCardStatus();
      }
    } else {
      clearInterval(this.cardSellForm.intervalQueryCardStatus);
      this.cardSellForm.intervalQueryCardStatus = null;
    }
  }
  async watchPendingCardStatus() {
    this.cardSellForm.intervalQueryCardStatus = setInterval(() => {
      this.getUserCards();
    }, 1000);
  }
  async handleCardSell() {
    const { paymentGateway, card, payCode, coupon } = this.cardSellForm;
    const { id } = this.searchUserForm.user;
    switch (paymentGateway) {
      case "scan":
        if (!this.cardSellForm.scanPayCode) {
          this.cardSellForm.scanPayCode = true;
          this.focusCardPayCodeScanInput();
          return;
        }
        break;
      case "cash":
        openDrawer();
        if (!this.cardSellForm.confirm) {
          openDrawer();
          this.cardSellForm.confirm = true;
          return;
        }
        break;
      case "customerscan":
        if (!this.cardSellForm.confirm) {
          this.cardSellForm.confirm = true;
          return;
        }
        break;
    }
    this.cardSellForm.loading = true;
    const [err, res] = await helpers.runAsync(userDeposit({ id, card, paymentGateway, paymentPending: true, payCode, coupon: coupon?.id }));
    this.cardSellForm.loading = false;

    const cardCreated = res.data;
    if (cardCreated.status === CardStatus.PENDING) {
      this.watchPendingCardStatus();
    }

    if (this.cardSellForm.confirm) {
      this.cardSellForm.confirm = false;
    }
    if (err) {
      this.cardSellForm.payCode = "";
      this.cardSellForm.scanPayCode = false;
      return;
    }
    this.refreshSearchUser();
  }
  async confirmCardPayment() {
    this.cardSellForm.loading_confirm = true;
    await this.handleCardSell();
    this.cardSellForm.loading_confirm = false;
    this.cardSellForm.confirm = false;
  }
  cancelCardPayment() {
    this.cardSellForm.confirm = false;
  }
  async activateCard(card) {
    await updateCard(card.id, { status: CardStatus.ACTIVATED });
    this.getUserCards();
  }
  async handleBindCardNo() {
    this.searchUserForm.bindCard_loading = true;
    const { cardNo } = this.searchUserForm;
    const { id } = this.searchUserForm.user;
    const [err, res] = await helpers.runAsync(updateUser({ cardNo, id }));
    this.searchUserForm.bindCard_loading = false;
    if (err) {
      return;
    }
    this.searchUserForm.user.cardNo = res.data.cardNo;
  }
  goCreateUser() {
    Object.assign(this.createUserForm, {
      mobile: "",
      username: "",
      gender: 0
    });
    if (this.searchUserForm.searchText?.length === 11) {
      this.createUserForm.mobile = this.searchUserForm.searchText;
    }
    this.step = "createUser";
    setTimeout(() => {
      (this.$refs.customerNameInput as Vue).$el.querySelector("input").focus();
    });
  }
  async createBookingFromSearchUser() {
    this.createBookingForm.user = this.searchUserForm.user;
    this.step = "createBooking";
  }
  async createUser() {
    const { mobile, username, gender, idCardNo } = this.createUserForm;
    const res = await signup({ username, gender, mobile, idCardNo });
    this.searchUserForm.user = res.data;
    this.refreshSearchUser();
  }
  async updateUser() {
    const { id } = this.searchUserForm.user;
    const { idCardNo, isForeigner, country } = this.createUserForm;
    const res = await updateUser({ id, idCardNo, isForeigner, country });
    this.searchUserForm.user = res.data;
    this.refreshSearchUser();
  }
  goCheckIn(booking) {
    this.$router.push(`/booking/detail/${booking.id}?checkIn=true`);
  }
  focusPayCodeScanInput() {
    setTimeout(() => {
      (this.$refs.payCodeScanInput as Vue).$el.querySelector("input").focus();
    });
  }
  focusCardPayCodeScanInput() {
    setTimeout(() => {
      (this.$refs.cardPayCodeScanInput as Vue).$el.querySelector("input").focus();
    });
  }
  async createBooking() {
    let { type, date, checkInAt, adultsCount, kidsCount, socksCount, hours, payCode } = this.createBookingForm.form;
    const { id: customerId } = this.createBookingForm.user;
    const { id: couponId } = this.createBookingForm.coupon || {};
    const { id: cardId } = this.createBookingForm.card || {};
    const { paymentGateway } = this;

    switch (paymentGateway) {
      case "scan":
        if (!this.createBookingForm.scanPayCode && this.createBookingForm.price - this.creditPrice > 0) {
          this.createBookingForm.scanPayCode = true;
          this.focusPayCodeScanInput();
          return;
        }
        break;
      case "cash":
        if (!this.createBookingForm.confirm) {
          openDrawer();
          this.createBookingForm.confirm = true;
          return;
        }
        break;
      case "customerscan":
        if (!this.createBookingForm.confirm) {
          this.createBookingForm.confirm = true;
          return;
        }
        break;
      case "credit":
        break;
    }

    this.createBookingForm.loading_createBooking = true;

    const [err, res] = await helpers.runAsync(
      createBooking({
        store: this.currentStore.id,
        type,
        date,
        hours,
        card: cardId,
        coupon: couponId,
        customer: customerId,
        checkInAt: moment().format("HH:mm:ss"),
        adultsCount,
        kidsCount,
        socksCount,
        useBalance: true,
        paymentGateway: paymentGateway == "credit" ? null : paymentGateway,
        paymentPending: true,
        payCode
      })
    );
    this.createBookingForm.loading_createBooking = false;
    if (err) {
      this.createBookingForm.form.payCode = "";
      return;
    }
    const { payments, price, id: businessId } = res.data;
    const [payment] = payments.filter((p) => !["coupon", "card"].includes(p.gateway));
    this.createBookingForm.newBooking = res.data;
    if (paymentGateway !== "scan") {
      this.goCheckIn(this.createBookingForm.newBooking);
    } else {
      this.watchNewBookingPayStatusInterval = setInterval(async () => {
        this.createBookingForm.newBooking = (await getBooking({ id: this.createBookingForm.newBooking.id })).data;
        if (this.createBookingForm.newBooking.status !== "pending") {
          this.createBookingForm.form.payCode = "";
          this.createBookingForm.scanPayCode = false;
          clearInterval(this.watchNewBookingPayStatusInterval);
          if (this.createBookingForm.newBooking.status !== "canceled") {
            this.goCheckIn(this.createBookingForm.newBooking);
          }
        }
      }, 1000);
    }
  }
  async confirmPayment() {
    this.createBookingForm.loading_confirm = true;
    await this.createBooking();
    this.createBookingForm.loading_confirm = false;
    this.goCheckIn(this.createBookingForm.newBooking);
  }
  cancelPayment() {
    this.createBookingForm.confirm = false;
  }
  getDropDownText(i) {
    return `${i.checkInAt}-${i.hours ? i.hours + "小时" : "畅玩"}-${i.adultsCount + i.kidsCount}人`;
  }
  handleBack() {
    if (this.step == "searchUser") {
      return this.$router.go(-1);
    }
    this.step = "searchUser";
  }
  beforeMount() {
    this.parseQuery();
  }
  beforeDestroy() {
    clearInterval(this.watchNewBookingPayStatusInterval);
    clearInterval(this.cardSellForm.intervalQueryCardStatus);
    this.cardSellForm.intervalQueryCardStatus = null;
  }
}
